import {TemperatureAPI} from "./temperature";
import {API} from "./base";
import {GenericResponse} from "./generic";
import {Sensor} from "./sensor";
import {OrderDirection} from "../components/generic/table";

export type SensorSetFilter = {
    ids?: number[];
};

export type SensorSetOrder = {
    attribute: "id" | "name"
    direction: OrderDirection
}

export type SensorSetAttributes =
    "id"
    | "name"
    | "url"
    | "sensors";


export type SensorSetsRequest = {
    filter?: SensorSetFilter;
    order?: SensorSetOrder[];
    attributes?: SensorSetAttributes[];
    offset?: number;
    limit?: number;
};

export type NewSensorSet = {
    name: string;
    sensors?: Sensor[];
}

export type SensorSet = {
    id: number;
    url: string;
} & NewSensorSet;

export type SensorSetsResponse = GenericResponse<{
    sensor_sets: SensorSet[];
}>;

export type SensorUpdateRequest = {
    id: number;
    name?: string;
    sensors?: Sensor[];
    sensors_update_mode?: "overwrite" | "append" | "subtract";
}

export class SensorSetAPI extends API {
    constructor(api: TemperatureAPI) {
        super(api.clientId, api.refreshTokenUrl, "/api/v3/sensor-set/")
    }

    async get(request: SensorSetsRequest = {}): Promise<SensorSetsResponse> {
        const url = new URL("", this.base);

        for (const [param, filter] of Object.entries({
            "id": request.filter?.ids,
            "order": request.order ? request.order.map(o => `${o.attribute}:${o.direction}`) : undefined,
            "attribute": request.attributes,
        })) {
            if (filter !== undefined) {
                for (const val of filter) {
                    url.searchParams.append(param, val.toString());
                }
            }
        }

        for (const [param, val] of Object.entries({
            "offset": request.offset,
            "limit": request.limit,
        })) {
            if (val !== undefined) {
                url.searchParams.set(param, val.toString());
            }
        }

        return (await this.fetchJSON<SensorSetsResponse>(url));
    }

    async create(set: NewSensorSet): Promise<GenericResponse> {
        return await this.postJSON(``, set, "PUT");
    }

    async update(req: SensorUpdateRequest): Promise<GenericResponse> {
        return await this.postJSON(`${req.id}`, {
            name: req.name ?? null,
            sensors: req.sensors,
            sensors_update_mode: req.sensors_update_mode
        }, "PATCH");
    }

    async remove(id: number): Promise<GenericResponse> {
        return await this.fetchJSON<GenericResponse>(`${id}`, {method: "DELETE"});
    }
}
